import { render, staticRenderFns } from "./XianxiaXingweiFenxiDetail.vue?vue&type=template&id=2a217114&scoped=true&"
import script from "./XianxiaXingweiFenxiDetail.vue?vue&type=script&lang=js&"
export * from "./XianxiaXingweiFenxiDetail.vue?vue&type=script&lang=js&"
import style0 from "./XianxiaXingweiFenxiDetail.vue?vue&type=style&index=0&id=2a217114&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a217114",
  null
  
)

export default component.exports